<div class="flex flex-col">
  @if (isDesktop) {
    <div class="flex flex-row items-center px-8 pt-6 justify-between">
      <div class="text-neutral-900 text-2xl font-semibold leading-[32px]">
        {{ 'language_dialog.title' | translate }}
      </div>
      <button [mat-dialog-close]="null" dsw-medium-icon-button="none" dswSuffix mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </div>
  } @else {
    <div class="flex flex-col" mat-dialog-title>
      <div class="flex flex-row items-center px-4 justify-start">
        <button [mat-dialog-close]="null" mat-button>
          <mat-icon>arrow_back</mat-icon>
          <span>{{ 'common.back' | translate }}</span>
        </button>
      </div>
    </div>
  }

  <div mat-dialog-content cdkFocusInitial>
    <div class="flex flex-col w-full">
      <p>{{ 'language_dialog.description' | translate }}</p>

      @if (appLocales$ | async; as allLanguages) {
        <dsw-language-switcher
          class="pt-6 w-full"
          [mode]="'dropdown'"
          [currentLocale]="translate.currentLang"
          [supportedLocales]="allLanguages"
          (localeChanged)="selectedLanguage = $event"
        ></dsw-language-switcher>
      }
    </div>
  </div>

  <div class="flex justify-end gap-4 px-8 pb-6">
    @if (isDesktop) {
      <button mat-dialog-close dsw-secondary-button dsw-medium-button class="mt-[8px]">
        {{ 'language_dialog.cancel' | translate }}
      </button>
    }
    <button
      [mat-dialog-close]="selectedLanguage"
      dsw-primary-button
      dsw-medium-button
      class="mt-[8px]"
      [class.w-full]="!isDesktop"
    >
      {{ 'language_dialog.apply' | translate }}
    </button>
  </div>
</div>
